import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { AuthService } from "src/app/services/auth.service";
import { LoginModel } from "src/app/models/login.model";
import { ShipmentModel } from "src/app/models/shipment.model";
import { WareHouseDropdownList,WarehouseLocations} from "src/app/models/warehouse.model";
import { GridActionsService } from "src/app/data-grid/grid-actions.service";
import { SnackbarComponent } from "src/app/components/snackbar/snackbar.component";
import { LogisticService } from "../../logistic/logistic.service";

@Component({
  selector: "app-popup-logistic-wh-location",
  templateUrl: "./popup-logistic-wh-location.component.html",
  styleUrls: ["./popup-logistic-wh-location.component.scss"],
})
export class PopupLogisticWhLocationComponent implements OnInit,OnDestroy {
  whLocationForm: FormGroup = new FormGroup({
    warehouseId: new FormControl(null,Validators.required),
    locationCode: new FormControl("",Validators.required),
    aside: new FormControl(null,Validators.required),
    side:new FormControl(""),
    shelf:new FormControl(""),
    bin:new FormControl(null),
  });

  public whs: WareHouseDropdownList[] = [];
  public warehouseId: number;
  public shipment: ShipmentModel;
  private destroy$ = new Subject<void>();
  public locationId: number = 0;
  isDisableWarehouse = null;
  loading: boolean= false;

  constructor(
    private logisticsService: LogisticService,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<PopupLogisticWhLocationComponent>,
    private gridActionsService: GridActionsService,
    @Inject(MAT_DIALOG_DATA) public dialogData
  ) {}

  ngOnInit(): void {
    this.authService.userInfo$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: LoginModel) => {
        this.whLocationForm.patchValue({ submittedBy: res.username });
      });

    this.GetWareHouseList();

    if (this.dialogData) {
      this.locationId = this.dialogData.data.locationid;
      if (
        this.dialogData?.data?.locationid > 0 &&
        this.dialogData?.data?.ItemCount
      ) {
        this.isDisableWarehouse = true;
      } else {
        this.isDisableWarehouse = null;
      }
      this.whLocationForm.patchValue({
        warehouseId: this.dialogData.data.WarehouseId,
        locationCode: this.dialogData.data.LocationCode,
      });
    } else {
      this.whLocationForm.patchValue({
        warehouseId: 1,
      });
    }
  }
  GetWareHouseList() {
    this.logisticsService
      .GetAllWareHouseList()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: WareHouseDropdownList[]) => {
        if (response) {
          this.whs = response;
        }
      });
    if (this.whs == null) {
      this.whs = [];
    }
  }

  action(e): void {
    if (e === "Save" || e === "Update") {
      this.save();
    } else {
      this.dialogRef.close(e);
    }
  }

  save(): void {
    this.loading= true;
    const payload:any = {};
    payload.warehouseId = Number(this.whLocationForm.controls.warehouseId.value);
    payload.locationCode = this.whLocationForm.controls.locationCode.value;
    if (payload.locationCode == "") {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: "Please input location code.",
            action: 'Dismiss',
            type: 'error',
          },
        });
      return;
    }
    if (this.locationId > 0) {
      payload.locationId = this.locationId;
    }
    this.logisticsService.registerMember(payload).pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.loading= false;
      this.snackBar.openFromComponent(SnackbarComponent, {
        duration: 3000,
        horizontalPosition: 'center',
        data: {
          title: `WhLocation ` +
          (this.dialogData ? "updated" : "added") +
          ` successfully`,
          action: 'Dismiss',
          type: 'info',
        },
      });
      this.gridActionsService.refresh();
      this.dialogRef.close();
    });
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  valueChange($event){
    if($event.target.value ){
      let value = $event.target.value.split('-');
      this.whLocationForm.patchValue({
        aside:Number(value[0]),
        side:value[1],
        shelf:value[2],
        bin:Number(value[3])
      });
    }    
  }

  changeValue($event, label): void {
    if($event.target.value ){
      this.whLocationForm.patchValue({ [label]: $event.target.value });
      const aside = this.whLocationForm.get('aside')?.value || '';
      const side = this.whLocationForm.get('side')?.value || '';
      const shelf = this.whLocationForm.get('shelf')?.value || '';
      const bin = this.whLocationForm.get('bin')?.value || '';
      const locationCode = `${aside}-${side}-${shelf}-${bin}`;    
      this.whLocationForm.patchValue({ locationCode });
    }    
  }
  onLetterInput(event: any): void {
    const inputValue = event.target.value;
    if (!/^[A-Z]*$/.test(inputValue)) {
      event.target.value = inputValue.replace(/[^A-Z]/g, '');
    }
    if (inputValue.length > 1) {
      event.target.value = inputValue.slice(0, 1);
    }
  }
  onDigitInput(event: any): void {
    const inputValue = event.target.value;
    if (inputValue.length > 1) {
      event.target.value = inputValue.slice(0, 1);
    }
    if (Number(inputValue) < 0 || Number(inputValue) > 9) {
      event.target.value = '';
    }
  }
}
